import axios from 'axios';
import Cookies from 'js-cookie';











export const basicUrl = process.env.REACT_APP_API_GETWAY+`/`;

console.log("basic url",basicUrl);
const service = axios.create({
  baseURL: basicUrl,
// baseURL:"http://localhost:8106/"
});



export const token = Cookies.get('ACCESS_TOKEN') || '';
service.interceptors.request.use(
  (config) => {
    
    
    const languageformat = "";
    if (token) {
      config.headers["Content-Type"] = config.responseType === "arraybuffer" && JSON.stringify(config.data) === "{}"
        ? "application/octet-stream;charset=utf-8"
        : "application/json;charset=utf-8";
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Accept-Language"] = languageformat || "";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


service.interceptors.response.use(
  (response) => {
    
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
     console.log("call the refresh token api here");
    }
    return Promise.reject(error);
  }
);

export default service;